export const truncateAssetName = (name, maxLength = 15) => {
  if (!name || name.length <= maxLength) {
    return name;
  }
  return name.substring(0, maxLength) + '...';
};
